<div class="tab-content-container mt-3 mb-2">
    <h4 class="border-bottom">History</h4>
    <ejs-grid #historyTabGrid
        [dataSource]="dataSource"
        [allowPaging]="true"
        [pageSettings]="{ pageSize: 10, pageSizes: [10, 20, 50, 100] }"
        [allowFiltering]="true"
        [allowSorting]="true"
        [allowResizing]="true"
        [allowReordering]="true"
        [showColumnChooser]="true"
        [allowExcelExport]="true"
        [filterSettings]="{ type: 'Menu' }"
        [columns]="gridColumns"
        (toolbarClick)="toolbarClick($event, historyTabGrid)"
        (actionComplete)="onGridActionComplete($event, historyTabGrid)"
        (created)="onGridCreated(historyTabGrid)">
    </ejs-grid>

    <ng-template #historyTabGridColumnChooser>
        <app-column-chooser
            [grid]="historyTabGrid"
            (onClose)="showColumnChooser = false"
        ></app-column-chooser>
    </ng-template>
</div>